import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { buildPosterUrl, fmtDate, fmtViews } from '../../utils/format';
import { avatarGradient } from '../../utils/avatar';

function AvatarBubble({ name, size = 34 }) {
    const ch = (name || '?')[0].toUpperCase();
    return (
        <div style={{
            width: size, height: size, borderRadius: '50%', flexShrink: 0,
            background: avatarGradient(name),
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: size * 0.42, fontWeight: 700,
            fontFamily: "'Manrope', sans-serif",
        }}>{ch}</div>
    );
}

/**
 * Карточка комментария в ленте «Последние комментарии».
 * Целиком является <a href="/watch/:id"> — краулеры идут по ссылке, SPA перехватывает клик.
 */
export default function LatestCommentCard({ comment, compact = false }) {
    const navigate = useNavigate();
    const href = `/watch/${comment.video_id}`;
    const poster = buildPosterUrl(comment.video_poster);

    return (
        <a
            href={href}
            onClick={(e) => { e.preventDefault(); navigate(href); }}
            style={{
                display: 'flex', gap: 12, textDecoration: 'none',
                minWidth: 0, overflow: 'hidden',
                padding: compact ? 10 : 12,
                background: '#0E0E11',
                border: '1px solid #1F1F23',
                borderRadius: 14,
                transition: 'border-color 140ms, background 140ms, transform 140ms',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#3F3F46';
                e.currentTarget.style.background  = '#131316';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#1F1F23';
                e.currentTarget.style.background  = '#0E0E11';
            }}
        >
            <AvatarBubble name={comment.username} size={compact ? 30 : 34} />

            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                    display: 'flex', alignItems: 'baseline', gap: 6,
                    marginBottom: 4, fontSize: 12,
                }}>
                    <span style={{
                        color: '#fff', fontWeight: 600,
                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        maxWidth: 160,
                    }}>
                        {comment.username || 'Аноним'}
                    </span>
                    <span style={{
                        color: '#52525B', fontSize: 10,
                        fontFamily: "'JetBrains Mono', monospace", flexShrink: 0,
                    }}>
                        {fmtDate(comment.created_at)}
                    </span>
                </div>

                <p style={{
                    margin: 0, fontSize: 13, lineHeight: 1.55, color: '#D4D4D8',
                    overflowWrap: 'anywhere',
                    display: '-webkit-box', WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: compact ? 2 : 3, overflow: 'hidden',
                }}>
                    {comment.content}
                </p>

                <div style={{
                    marginTop: 8, display: 'flex', alignItems: 'center', gap: 6,
                    fontSize: 11, color: '#71717A', minWidth: 0,
                }}>
                    <Icon name="comment" size={12} color="#e60073" stroke={2} />
                    <span style={{
                        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}>
                        {comment.video_title}
                    </span>
                </div>
            </div>

            {poster && (
                <div style={{
                    width: compact ? 46 : 56, flexShrink: 0,
                    aspectRatio: '2 / 3', borderRadius: 10, overflow: 'hidden',
                    background: '#131316', position: 'relative',
                }}>
                    <img
                        src={poster}
                        alt={comment.video_title || ''}
                        loading="lazy"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    />
                    {!compact && comment.video_views > 0 && (
                        <div style={{
                            position: 'absolute', left: 0, right: 0, bottom: 0,
                            padding: '10px 4px 3px',
                            background: 'linear-gradient(transparent, rgba(0,0,0,0.85))',
                            fontFamily: "'JetBrains Mono', monospace",
                            fontSize: 9, color: '#D4D4D8', textAlign: 'center',
                        }}>
                            {fmtViews(comment.video_views)}
                        </div>
                    )}
                </div>
            )}
        </a>
    );
}
